module.exports = __webpack_public_path__ + "img/cdu-abgeordneter-steuergeld.2fab9eeb.jpg";